import { WorkInjuryEmployerLiabilityBundle } from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorWorkersCompLimitReverse = (
  limits: insuranceMonitorSettingsApiSpec.CoverageLimit[]
): WorkInjuryEmployerLiabilityBundle | undefined => {
  const eachAccident = limits.find(
    l => l.limitType === "EmployersLiabilityEachAccident"
  );
  const diseasePolicyLimit = limits.find(
    l => l.limitType === "EmployersLiabilityDiseasePolicyLimit"
  );

  if (!eachAccident || !diseasePolicyLimit) {
    return undefined;
  }

  const accidentAmount = eachAccident.amount;
  const diseaseAmount = diseasePolicyLimit.amount;

  if (accidentAmount === 1000000 && diseaseAmount === 1000000) {
    return WorkInjuryEmployerLiabilityBundle.OneMillionBundle;
  }

  if (accidentAmount === 1000000 && diseaseAmount === 500000) {
    return WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred;
  }

  if (accidentAmount === 500000 && diseaseAmount === 500000) {
    return WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred;
  }

  return undefined;
};
